import { Outlet, NavLink } from 'react-router-dom'
import MyIcon from '../../components/general/icon'

export default function Nav() {
  const computedClassName = ({ isActive }) => {
    return isActive ?  "main-nav-menu main-nav-menuActive" : "main-nav-menu"
  }

  return (
    <div className="main-nav-page">
      <div className="main-nav-container">
        <div className="main-nav-box">
          <div className="main-nav-title">风采管理</div>
          <NavLink to="coach" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='gangwei' /></div>
            <div className="main-nav-name">教练风采</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="enthusiast" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='renwu' /></div>
            <div className="main-nav-name">达人风采</div>
            <div className="main-nav-number"></div>
          </NavLink>
        </div>

        <div className="main-nav-box">
          <div className="main-nav-title">健身管理</div>
          <NavLink to="fitnessSeries" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='renxiangfenlei' /></div>
            <div className="main-nav-name">健身系列</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="fitnessVideo" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='shipin' /></div>
            <div className="main-nav-name">健身视频</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="fitnessArticle" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='zhishiku' /></div>
            <div className="main-nav-name">健身科普</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="ingredient" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='zhaoshengxinxi' /></div>
            <div className="main-nav-name">运动食材</div>
            <div className="main-nav-number"></div>
          </NavLink>
        </div>

        <div className="main-nav-box">
          <div className="main-nav-title">预约管理</div>
          <NavLink to="appointment" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='jihua' /></div>
            <div className="main-nav-name">预约记录</div>
            <div className="main-nav-number"></div>
          </NavLink>
        </div>

        <div className="main-nav-box">
          <div className="main-nav-title">问卷&体测</div>
          <NavLink to="physicalTest" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='fenshu' /></div>
            <div className="main-nav-name">体测记录</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="questionnaire" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='shoujibiaodan' /></div>
            <div className="main-nav-name">筛查问卷</div>
            <div className="main-nav-number"></div>
          </NavLink>
        </div>

        <div className="main-nav-box">
          <div className="main-nav-title">用户管理</div>
          <NavLink to="user" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='xuesheng' /></div>
            <div className="main-nav-name">普通用户</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="member" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='VIP' /></div>
            <div className="main-nav-name">会员用户</div>
            <div className="main-nav-number"></div>
          </NavLink>
          <NavLink to="notice" className={computedClassName}>
            <div className="main-nav-icon"><MyIcon name='tongzhi' /></div>
            <div className="main-nav-name">通知消息</div>
            <div className="main-nav-number"></div>
          </NavLink>
        </div>
      </div>
      <Outlet />
    </div>
  )
}
